import { render, staticRenderFns } from "./FeaturedDormsNoTabs.vue?vue&type=template&id=7d4b2f80&scoped=true&"
import script from "./FeaturedDormsNoTabs.vue?vue&type=script&lang=js&"
export * from "./FeaturedDormsNoTabs.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedDormsNoTabs.vue?vue&type=style&index=0&id=7d4b2f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4b2f80",
  null
  
)

export default component.exports